import { render, staticRenderFns } from "./customer_folder_portal.vue?vue&type=template&id=1587aea8&scoped=true&"
import script from "./customer_folder_portal.vue?vue&type=script&lang=js&"
export * from "./customer_folder_portal.vue?vue&type=script&lang=js&"
import style0 from "./customer_folder_portal.vue?vue&type=style&index=0&id=1587aea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1587aea8",
  null
  
)

export default component.exports